module.exports = __webpack_public_path__ + "media/images/sec_3-4-9ecb4bddeb4e9cb61a50a281b03ecd6c.png";